import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import $ from 'jquery';
import './Leftsidebar.css';
import { Translate } from '../../contexts/Language';

let activeTab = window.location.pathname.replace('/', '');

if (activeTab.indexOf('/')) {
  [activeTab] = activeTab.split('/');
}

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Tab: activeTab,
    };
    this.setActiveTab = this.setActiveTab.bind(this);
  }


  componentDidMount() {
    if ($(window).width() < 1025) {
      $('body').addClass('enlarged');
    } else {
      $('body').removeClass('enlarged');
    }

    $('.button-menu-mobile').on('click', event => {
      event.preventDefault();
      $('body').toggleClass('enlarged');
    });
  }

  setActiveTab(tab) {
    this.setState({ Tab: tab });
    if ($(window).width() < 1025) {
      $('body').addClass('enlarged');
    }
  }

  render() {
    const { onLogout } = this.props;
    const { Tab } = this.state;
    return (
      <div className="left side-menu">
        <Scrollbars className="Scrollbars">
          <div>
            <div id="sidebar-menu">
              <ul className="metismenu" id="side-menu">
                <li className="menu-title">Main</li>
                <li>
                  <Link to="/home" className={Tab === 'home' || Tab === '' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('home')}>
                    <i className="fas fa-home" />
                    <span> Home </span>
                  </Link>
                </li>
                <li className="menu-title">{Translate('Money Transfer')}</li>
                <li>
                  <Link to="/withdrawal" className={Tab === 'withdrawal' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('withdrawal')}>
                    <i className="fas fa-money-bill-alt" />
                    <span> Withdrawal </span>
                  </Link>
                </li>
                <li>
                  <Link to="/deposit" className={Tab === 'deposit' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('deposit')}>
                    <i className="fas fa-coins" />
                    <span> Deposit </span>
                  </Link>
                </li>
                <li>
                  <Link to="/internal-transfer" className={Tab === 'internal-transfer' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('internal-transfer')}>
                    <i className="fas fa-exchange-alt" />
                    <span> Internal Trasfer </span>
                  </Link>
                </li>
                <li className="menu-title">{Translate('Transfer Options')}</li>
                <li>
                  <Link to="/payment-services" className={Tab === 'payment-services' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('payment-services')}>
                    <i className="fas fa-money-check-alt" />
                    <span> Payment Services </span>
                  </Link>
                </li>
                <li>
                  <Link to="/rules" className={Tab === 'rules' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('rules')}>
                    <i className="fas fa-list" />
                    <span> PSP Rules </span>
                  </Link>
                </li>
                <li>
                  <Link to="/daily-limit" className={Tab === 'daily-limit' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('daily-limit')}>
                    <i className="fas fa-calendar-day" />
                    <span> PSP Daily Limit </span>
                  </Link>
                </li>
                <li>
                  <Link to="/white-list" className={Tab === 'white-list' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('white-list')}>
                    <i className="fas fa-user-check" />
                    <span> White List </span>
                  </Link>
                </li>
                <li>
                  <Link to="/black-list" className={Tab === 'black-list' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('black-list')}>
                    <i className="fas fa-user-times" />
                    <span> Black List </span>
                  </Link>
                </li>
                <li>
                  <Link to="/page-role" className={Tab === 'page-role' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('page-role')}>
                    <i className="fas fa-copy" />
                    <span> Page Role </span>
                  </Link>
                </li>
                <li className="menu-title">Common</li>
                <li>
                  <Link to="/customer-documents" className={Tab === 'customer-documents' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('customer-documents')}>
                    <i className="fas fa-copy" />
                    <span> Customer Documents </span>
                  </Link>
                </li>
                <li>
                  <Link to="/users" className={Tab === 'users' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('users')}>
                    <i className="fas fa-users" />
                    <span> Users </span>
                  </Link>
                </li>
                <li>
                  <Link to="/settings" className={Tab === 'settings' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('settings')}>
                    <i className="fas fa-cog" />
                    <span> Settings </span>
                  </Link>
                </li>
                <li>
                  <Link to="/currency-settings" className={Tab === 'currency-settings' ? 'waves-effect active' : 'waves-effect'} onClick={() => this.setActiveTab('currency-settings')}>
                    <i className="fas fa-money-check-alt" />
                    <span> Currency Settings </span>
                  </Link>
                </li>
                <li>
                  <a href="#top" className="waves-effect" onClick={e => onLogout(e)}>
                    <i className="ti-power-off" />
                    <span> Logout </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="clearfix" />
          </div>
        </Scrollbars>
      </div>
    );
  }
}

SideBar.propTypes = {
  onLogout: PropTypes.func.isRequired,
};

export default SideBar;
